import { render, staticRenderFns } from "./MarketingStockAdmin.vue?vue&type=template&id=01409864&scoped=true"
import script from "./MarketingStockAdmin.vue?vue&type=script&lang=js"
export * from "./MarketingStockAdmin.vue?vue&type=script&lang=js"
import style0 from "./MarketingStockAdmin.vue?vue&type=style&index=0&id=01409864&prod&scoped=true&lang=css"
import style1 from "./MarketingStockAdmin.vue?vue&type=style&index=1&id=01409864&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01409864",
  null
  
)

export default component.exports